module.exports = __webpack_public_path__ + "static/media/appreciation-letter-img-2.ded42f31.jpg";